import React, { useState, useEffect } from 'react'
import axios from 'axios';

function PopularService() {
    const [Service, setServices] = useState([])

    const services = async () => {
        const { data } = await axios.post('https://api.compliancekare.com/api/getservice');
        setServices(data);
    }
    useEffect(() => {
        services();
    }, []);
    return (
        <>
            <div class="container pt-2">
                <h1 style={{ textAlign: "center", fontSize: "1.8rem", fontFamily: "poppins" }} ><b>Popular Services.</b></h1>
                <h3 style={{ textAlign: "center", fontSize: "1.4rem", fontFamily: "poppins" }} class="p-2"><b>Looking for tax-services we’re here to help.</b></h3>
                <div class="row">
                    {Service?.map((item, index) => {

                        return (

                            <div class="col-md-4">
                                <div class="card" >
                                    <img src="https://www.canarahsbclife.com/content/dam/choice/tax-university/images/how-to-file-income-tax-return-itr-for-last-years.jpg" class="card-img-top " alt="..." style={{ height: "200px" }} />
                                    <div class="card-body">
                                        <h5 class="card-title text-center" style={{fontFamily:"poppins",fontSize:"23px",fontWeight:"600"}}>{item.serviceName}</h5>
                                        <p class="card-text"  style={{fontFamily:"poppins",fontSize:"18px",textAlign:"justify"}}>{item.serviceDescription}</p>
                                        <a href="#" class="btn btn-primary">Upload Now</a>
                                    </div>
                                </div>
                            </div>

                        )
                    })}

                </div>
            </div>

        </>
    )
}

export default PopularService